/**
 * A Listener genie's listening alerts (agents.listen_alerts). Mirrors
 * supabase/functions/_shared/listener/alerts.ts, where the alerts, daily
 * brief and nudges are sent.
 */
export interface ListenAlertSettings {
  urgent_alerts: boolean;
  daily_brief: boolean;
  nudge_hours: number | null;
  sms_numbers: string[];
  call_recaps: boolean;
}

export const DEFAULT_LISTEN_ALERTS: ListenAlertSettings = {
  urgent_alerts: true,
  daily_brief: true,
  nudge_hours: 6,
  sms_numbers: [],
  call_recaps: false,
};

export const MAX_LISTEN_SMS_NUMBERS = 3;
export const LISTEN_NUDGE_HOUR_OPTIONS = [2, 4, 6, 12, 24];

export const resolveListenAlertSettings = (raw: Partial<ListenAlertSettings> | null | undefined): ListenAlertSettings => ({
  ...DEFAULT_LISTEN_ALERTS,
  ...(raw ?? {}),
  sms_numbers: raw?.sms_numbers ?? [],
});
